export const returnUniqueValuesFromArray = (items) => {
  return [...new Map(items.map((item) => [item['id'], item])).values()];
};
